import { jsx as _jsx } from "react/jsx-runtime";
import { LiteralBase, getLiteralBaseProps, baseEditableOptions } from "./TextLiteral";
import { makeStyles } from "@material-ui/core";
import { FormattedNumber } from "react-intl";
import { identityRecordOfFieldEditorOptions } from "@ploy-ui/form-fields";
const useStylesTextAreaLiteral = makeStyles(theme => ({
    root: {
        whiteSpace: "pre-wrap",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: theme.spacing(1)
    }
}), { name: "DployTextAreaLiteral" });
export const TextArea = (props) => {
    const classesTextAreaLiteral = useStylesTextAreaLiteral(props);
    return (_jsx(LiteralBase, { ...getLiteralBaseProps({
            ...props,
            className: classesTextAreaLiteral.root,
            options: { ...props.options, literalVariant: "normal" }
        }), children: typeof props.field.value === "number" ? (_jsx(FormattedNumber, { maximumFractionDigits: 0, value: props.field.value })) : (props.field.value) }));
};
TextArea.displayName = "TextAreaLiteral";
export const TextAreaLiterals = identityRecordOfFieldEditorOptions({
    TextAreaLiteral: {
        editableOptions: {
            ...baseEditableOptions
        }
    }
});
//# sourceMappingURL=TextAreaLiteral.js.map